export const ABOUT_US = 'О НАС';
export const CONTACTS = 'КОНТАКТЫ';
export const BLOG = 'БЛОГ';
export const CONTACTS_US = 'Напишите нам';
export const HELP = 'ПОМОЩЬ В ПОДБОРЕ ТУРА';
export const LOCATION = 'Минск';
export const PHONE_COMMENT = 'Круглосуточная поддержка';
export const BUY_IN_OFFICE = 'Купить тур в офисе';
export const LOG_IN = 'Войти';
